export default "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAMCAYAAABr5z2BAAAAHklEQVR42mNgYGD4TyFm+J+WRh4eNWDUAOoaQAkGAL+QLuAssj7PAAAAAElFTkSuQmCC"